<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            探访记录
        </div>
        <div style="padding: 20px;">

            <div class="BerthPage">

                <el-row>
                    <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>

                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" v-loading="loading" :height="th" border style="width: 100%;">

                        <el-table-column prop="elderlyName" label="老人"></el-table-column>

                        <el-table-column prop="visitName" label="探访人"></el-table-column>

                        <el-table-column prop="visitPhone" label="探访人手机号"></el-table-column>

                        <el-table-column prop="remarks" label="描述详情"></el-table-column>

                        <el-table-column prop="createTime" :formatter="formatTime" label="记录时间"></el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-bind:options="options" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-bind:options="options" v-on:closeGetElderly="closeGetElderly" v-on:openAdd="openAdd"></GetElderly>

    </div>
</template>

<script>
    import Add from "./Add";
    import GetElderly from "./GetElderly";
    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Page",
        data(){
            return{
                loading:false,
                menuButtonList:null,
                disabledAdd:true,
                showModalAdd:false,
                showModalGetElderly:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                options:[]
            }
        },
        components:{
            Add,GetElderly
        },
        created(){
            this.init();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                if(menu!=null&&menu.length>0){
                    for(let i=0;i<menu.length;i++){
                        if(menu[i].buttonName=="添加"){
                            this.disabledAdd = false;
                        }
                    }
                }
            },
            init(){
                this.getList();
            },
            openAdd(data){
                this.closeAdd()
                this.$refs.myAdd.init(data);
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"VisitRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },

            handleGetElderly(index, row) {
                this.$refs.myGetElderly.init(row);
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            toggleModalAdd:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
                this.$refs.myGetElderly.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalGetElderly:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
            },
            closeGetElderly:function(){
                this.showModalGetElderly = !this.showModalGetElderly;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.init();
            },
            formatTime:function (row, column, cellValue) {
                return timefilters(cellValue);
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },

        }
    }
</script>

<style scoped>

</style>